<div [formGroup]="form" class="flex flex-column gap-2 multiselect-container">
  <label [attr.for]="item.key" class="font-semibold"
    >{{ item.label || '' | translate }}
    <span class="asterisk" *ngIf="item.required">*</span>
  </label>

  <p-multiSelect
    [formControlName]="item.key"
    styleClass="w-full"
    ngClass="{{ isInValid ? 'ng-invalid ng-dirty' : '' }}"
    [defaultLabel]="item.placeholder || placeholder | translate"
    [options]="item.options || []"
    optionLabel="label"
    optionValue="value"
  >
    <ng-template let-value pTemplate="selectedItems">
      <div *ngIf="value && value.length > 0">
        {{ value.length }} item(s) selected
      </div>
      <div *ngIf="!value || value.length < 1">
        {{ item.placeholder || placeholder | translate }}
      </div>
    </ng-template>
  </p-multiSelect>

  <div class="flex flex-wrap gap-2" *ngIf="value && value.length > 0">
    <p-chip
      class="mr-2"
      *ngFor="let item of value"
      [label]="getChipLabel(item)"
      [removable]="!disabled"
      (onRemove)="onRemove(item)"
    ></p-chip>
  </div>

  <small
    class="p-error block font-italic"
    *ngIf="isInValid && hasError('required')"
  >
    {{
      item.errorMessage?.required?.message || ''
        | translate : item.errorMessage?.required?.params
    }}
  </small>
</div>
